export default ({ authGuard, guestGuard }) => [
  { path: '/', redirect: '/bookings' },
  { path: '/booking/request', name: 'booking.request', component: require('~/pages/booking/request.vue') },
  // Authenticated routes.
  ...authGuard([
    { path: '/profile', name: 'profile', component: require('~/pages/profile.vue') },
    { path: '/bookings', name: 'bookings', component: require('~/pages/bookings.vue') },
    { path: '/booking/pay/:token', name: 'booking.pay', component: require('~/pages/booking/pay.vue') },
    { path: '/settings',
      component: require('~/pages/settings/index.vue'),
      children: [
      { path: '', redirect: { name: 'settings.password' } },
      { path: 'password', name: 'settings.password', component: require('~/pages/settings/password.vue') }
      ] }
 
  ]),

  // Guest routes.
  ...guestGuard([
    { path: '/login', name: 'login', component: require('~/pages/auth/login.vue') },
    { path: '/register', name: 'register', component: require('~/pages/auth/register.vue') },
    { path: '/register/completion/:token', name: 'register.completion', component: require('~/pages/auth/register_completion.vue') },
    { path: '/password/reset', name: 'password.request', component: require('~/pages/auth/password/email.vue') },
    { path: '/password/reset/:token', name: 'password.reset', component: require('~/pages/auth/password/reset.vue') }
  ]),

  { path: '/pay/:token', name: 'pay', component: require('~/pages/booking/pay.vue') },
  { path: '/pay/success/:token', name: 'pay_success', component: require('~/pages/booking/pay_success.vue') },
  { path: '/pay/aborted/:token', name: 'pay_aborted', component: require('~/pages/booking/pay_aborted.vue') },
  { path: '*', component: require('~/pages/errors/404.vue') }
]



// WEBPACK FOOTER //
// ./src/router/routes.js